"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Broker = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const broker_address_entity_1 = require("./broker-address.entity");
const broker_contact_entity_1 = require("./broker-contact.entity");
let Broker = class Broker {
};
exports.Broker = Broker;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Broker.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "broker_name",
        type: "varchar",
        length: 200,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Broker.prototype, "brokerName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "display_name",
        type: "varchar",
        length: 100,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Broker.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Broker.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "website", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Broker.prototype, "website", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Broker.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Broker.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Broker.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Broker.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Broker.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Broker.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamp", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Broker.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "company_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Broker.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _d : Object)
], Broker.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => broker_address_entity_1.BrokerAddress, (brokerAddress) => brokerAddress.broker, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Broker.prototype, "brokerAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => broker_contact_entity_1.BrokerContact, (brokerContact) => brokerContact.broker, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Broker.prototype, "brokerContacts", void 0);
exports.Broker = Broker = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "broker" })
], Broker);
